<!-- We are creating a signature -->
@if (addingSignature() === true) {
<div @collapseY>
    <div class="p-[4px] w-max border border-solid border-black rounded-[8px]">
        <app-signature-pad #sigpad [options]="sigPadOptions" (drawEnd)="drawEnd($event)" />
        <div class="flex justify-between items-center gap-2 p-[4px] mt-[4px]">
            <span>Draw your signature here</span>
            <button mat-raised-button color="primary" type="button" (click)="btnClearSignature(sigpad)">Clear</button>
            <button mat-raised-button color="warn" type="button" (click)="btnCancelSigning()">Cancel</button>
            <button mat-raised-button color="accent" type="button" (click)="btnSubmitSignature(sigpad)" [disabled]="disableSubmitButton()">
                Submit
            </button>
        </div>
    </div>
</div>
}
<!-- No signature found -->
@else if (inputSignature() == null) {
<div @collapseY class="flex justify-center">
    <button mat-raised-button color="accent" type="button" (click)="btnStartSigning()">Create Signature</button>
</div>
}
<!-- Display a signature -->
@else {
<div class="flex flex-wrap items-center gap-[10px]">
    <img [src]="inputSignature()" height="75" class="border border-solid border-black rounded-[8px]" />
    <button mat-raised-button color="accent" type="button" (click)="btnStartSigning()">Redo Signature</button>
</div>
}